export default template;
function pug_attr(t,e,n,r){if(!1===e||null==e||!e&&("class"===t||"style"===t))return"";if(!0===e)return" "+(r?t:t+'="'+t+'"');var f=typeof e;return"object"!==f&&"function"!==f||"function"!=typeof e.toJSON||(e=e.toJSON()),"string"==typeof e||(e=JSON.stringify(e),n||-1===e.indexOf('"'))?(n&&(e=pug_escape(e))," "+t+'="'+e+'"'):" "+t+"='"+e.replace(/'/g,"&#39;")+"'"}
function pug_classes(s,r){return Array.isArray(s)?pug_classes_array(s,r):s&&"object"==typeof s?pug_classes_object(s):s||""}
function pug_classes_array(r,a){for(var s,e="",u="",c=Array.isArray(a),g=0;g<r.length;g++)(s=pug_classes(r[g]))&&(c&&a[g]&&(s=pug_escape(s)),e=e+u+s,u=" ");return e}
function pug_classes_object(r){var a="",n="";for(var o in r)o&&r[o]&&pug_has_own_property.call(r,o)&&(a=a+n+o,n=" ");return a}
function pug_escape(e){var a=""+e,t=pug_match_html.exec(a);if(!t)return e;var r,c,n,s="";for(r=t.index,c=0;r<a.length;r++){switch(a.charCodeAt(r)){case 34:n="&quot;";break;case 38:n="&amp;";break;case 60:n="&lt;";break;case 62:n="&gt;";break;default:continue}c!==r&&(s+=a.substring(c,r)),c=r+1,s+=n}return c!==r?s+a.substring(c,r):s}
var pug_has_own_property=Object.prototype.hasOwnProperty;
var pug_match_html=/["&<>]/;function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;;
    var locals_for_with = (locals || {});
    
    (function (assetManager, availableCollections, availableExtras, collectionsById, extras, generalInventory, imageReorder, pendingChanges, product, renderDollars, sizes, uuid) {
      










pug_mixins["options_with_null"] = pug_interp = function(available, selected){
var block = (this && this.block), attributes = (this && this.attributes) || {};
pug_html = pug_html + "\u003Coption\u003E\u003C\u002Foption\u003E";
// iterate (available)
;(function(){
  var $$obj = (available);
  if ('number' == typeof $$obj.length) {
      for (var pug_index1 = 0, $$l = $$obj.length; pug_index1 < $$l; pug_index1++) {
        var v = $$obj[pug_index1];
pug_html = pug_html + "\u003Coption" + (pug_attr("value", v, true, true)+pug_attr("selected", (v == selected), true, true)) + "\u003E" + (pug_escape(null == (pug_interp = v) ? "" : pug_interp)) + "\u003C\u002Foption\u003E";
      }
  } else {
    var $$l = 0;
    for (var pug_index1 in $$obj) {
      $$l++;
      var v = $$obj[pug_index1];
pug_html = pug_html + "\u003Coption" + (pug_attr("value", v, true, true)+pug_attr("selected", (v == selected), true, true)) + "\u003E" + (pug_escape(null == (pug_interp = v) ? "" : pug_interp)) + "\u003C\u002Foption\u003E";
    }
  }
}).call(this);

};














pug_html = pug_html + "\u003Cdiv class=\"function-body\"\u003E\u003Cbutton" + (pug_attr("class", pug_classes(["save","pending-changes","clickable",{pending: pendingChanges}], [false,false,false,true]), false, true)) + "\u003ESave pending changes\u003C\u002Fbutton\u003E";
if (product && collectionsById) {
pug_html = pug_html + "\u003Cform class=\"details\"\u003E\u003Cdiv class=\"form-group\"\u003E\u003Clabel\u003EName\u003C\u002Flabel\u003E\u003Cinput" + (" class=\"form-control\""+" name=\"name\""+pug_attr("value", product.name, true, true)) + "\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"form-group\"\u003E\u003Clabel\u003EDescription\u003C\u002Flabel\u003E\u003Cdiv class=\"description-editor\"\u003E" + (null == (pug_interp = product.description) ? "" : pug_interp) + "\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"form-group\"\u003E\u003Clabel\u003ESpecial text for \"note to florist\" field (optional)\u003C\u002Flabel\u003E\u003Cinput" + (" class=\"form-control\""+" name=\"noteToFloristTxt\""+pug_attr("value", product.noteToFloristTxt, true, true)) + "\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"form-group product-visible\"\u003E\u003Clabel\u003E\u003Cinput" + (" class=\"boolean\""+" type=\"checkbox\" name=\"visible\""+pug_attr("checked", product.visible, true, true)+pug_attr("disabled", (sizes.length == 0), true, true)) + "\u003E\nVisible in shop";
if (sizes.length == 0) {
pug_html = pug_html + "\n(cannot be enabled without a product size)";
}
pug_html = pug_html + "\u003C\u002Flabel\u003E\u003C\u002Fdiv\u003E\u003C\u002Fform\u003E\u003Cdiv class=\"sizes-container\"\u003E\u003Ch2\u003ESizes\u002FOptions\u003C\u002Fh2\u003E\u003Cform class=\"add-size-container size\"\u003E\u003Clabel\u003EName\u003C\u002Flabel\u003E\u003Cinput name=\"description\"\u003E\u003Clabel\u003EPrice\u003C\u002Flabel\u003E\u003Cinput name=\"value\"\u003E\u003Cbutton class=\"add-size\"\u003EAdd new size\u003C\u002Fbutton\u003E\u003C\u002Fform\u003E\u003Cdiv class=\"sizes\"\u003E";
// iterate sizes
;(function(){
  var $$obj = sizes;
  if ('number' == typeof $$obj.length) {
      for (var idx = 0, $$l = $$obj.length; idx < $$l; idx++) {
        var size = $$obj[idx];
pug_html = pug_html + "\u003Cdiv" + (" class=\"size existing-size\""+pug_attr("data-idx", idx, true, true)) + "\u003E\u003Cdiv class=\"main\"\u003E\u003Cdiv class=\"pill\"\u003E" + (pug_escape(null == (pug_interp = size.description) ? "" : pug_interp)) + "\n\u003Cem\u003E(" + (pug_escape(null == (pug_interp = renderDollars(size.value)) ? "" : pug_interp)) + ")\u003C\u002Fem\u003E\n\u003Ca" + (" class=\"clickable delete-size\""+pug_attr("data-size", size.description, true, true)) + "\u003EX\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"image\"\u003E";
if (size.media && size.media.mainMedia) {
pug_html = pug_html + "\u003Cdiv\u003E";
if (size.media.mainMedia.thumbnail) {
pug_html = pug_html + "\u003Cimg" + (pug_attr("src", size.media.mainMedia.thumbnail.url, true, true)) + "\u003E";
}
else {
pug_html = pug_html + "\u003Cimg" + (pug_attr("src", size.media.mainMedia.image && size.media.mainMedia.image.url, true, true)) + "\u003E";
}
pug_html = pug_html + "\u003Cdiv\u003E\u003Ca" + (" class=\"remove-size-image clickable\""+pug_attr("data-idx", idx, true, true)) + "\u003Eremove\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";
}
else {
pug_html = pug_html + "\u003Ca" + (" class=\"add-size-image clickable\""+pug_attr("data-idx", idx, true, true)) + "\u003EAdd image\u003C\u002Fa\u003E";
}
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003Cdiv class=\"data\"\u003E\u003Cdiv class=\"change-price\"\u003E\u003Clabel\u003EChange price\u003C\u002Flabel\u003E\u003Cinput" + (" class=\"change-size-price\""+" size=\"5\""+pug_attr("value", size.value, true, true)) + "\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"hide\"\u003E\u003Clabel\u003EVisible in shop\u003C\u002Flabel\u003E\u003Cinput" + (" class=\"visibility-size\""+" type=\"checkbox\""+pug_attr("checked", size.visible, true, true)) + "\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"inventory-use\"\u003E";
// iterate (size.uses || [])
;(function(){
  var $$obj = (size.uses || []);
  if ('number' == typeof $$obj.length) {
      for (var pug_index4 = 0, $$l = $$obj.length; pug_index4 < $$l; pug_index4++) {
        var use = $$obj[pug_index4];
pug_html = pug_html + "\u003Cdiv class=\"use\"\u003EUses " + (pug_escape(null == (pug_interp = use.quantity) ? "" : pug_interp)) + " " + (pug_escape(null == (pug_interp = use.name) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E";
      }
  } else {
    var $$l = 0;
    for (var pug_index4 in $$obj) {
      $$l++;
      var use = $$obj[pug_index4];
pug_html = pug_html + "\u003Cdiv class=\"use\"\u003EUses " + (pug_escape(null == (pug_interp = use.quantity) ? "" : pug_interp)) + " " + (pug_escape(null == (pug_interp = use.name) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E";
    }
  }
}).call(this);

pug_html = pug_html + "\u003Cdiv class=\"add-use\"\u003E\u003Cselect name=\"inventory_use_name\"\u003E";
pug_mixins["options_with_null"](generalInventory);
pug_html = pug_html + "\u003C\u002Fselect\u003E\u003Cinput name=\"inventory_use_quantity\" type=\"number\"\u003E\u003Cbutton class=\"add-inventory-use\"\u003EAdd usage\u003C\u002Fbutton\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";
      }
  } else {
    var $$l = 0;
    for (var idx in $$obj) {
      $$l++;
      var size = $$obj[idx];
pug_html = pug_html + "\u003Cdiv" + (" class=\"size existing-size\""+pug_attr("data-idx", idx, true, true)) + "\u003E\u003Cdiv class=\"main\"\u003E\u003Cdiv class=\"pill\"\u003E" + (pug_escape(null == (pug_interp = size.description) ? "" : pug_interp)) + "\n\u003Cem\u003E(" + (pug_escape(null == (pug_interp = renderDollars(size.value)) ? "" : pug_interp)) + ")\u003C\u002Fem\u003E\n\u003Ca" + (" class=\"clickable delete-size\""+pug_attr("data-size", size.description, true, true)) + "\u003EX\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"image\"\u003E";
if (size.media && size.media.mainMedia) {
pug_html = pug_html + "\u003Cdiv\u003E";
if (size.media.mainMedia.thumbnail) {
pug_html = pug_html + "\u003Cimg" + (pug_attr("src", size.media.mainMedia.thumbnail.url, true, true)) + "\u003E";
}
else {
pug_html = pug_html + "\u003Cimg" + (pug_attr("src", size.media.mainMedia.image && size.media.mainMedia.image.url, true, true)) + "\u003E";
}
pug_html = pug_html + "\u003Cdiv\u003E\u003Ca" + (" class=\"remove-size-image clickable\""+pug_attr("data-idx", idx, true, true)) + "\u003Eremove\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";
}
else {
pug_html = pug_html + "\u003Ca" + (" class=\"add-size-image clickable\""+pug_attr("data-idx", idx, true, true)) + "\u003EAdd image\u003C\u002Fa\u003E";
}
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003Cdiv class=\"data\"\u003E\u003Cdiv class=\"change-price\"\u003E\u003Clabel\u003EChange price\u003C\u002Flabel\u003E\u003Cinput" + (" class=\"change-size-price\""+" size=\"5\""+pug_attr("value", size.value, true, true)) + "\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"hide\"\u003E\u003Clabel\u003EVisible in shop\u003C\u002Flabel\u003E\u003Cinput" + (" class=\"visibility-size\""+" type=\"checkbox\""+pug_attr("checked", size.visible, true, true)) + "\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"inventory-use\"\u003E";
// iterate (size.uses || [])
;(function(){
  var $$obj = (size.uses || []);
  if ('number' == typeof $$obj.length) {
      for (var pug_index5 = 0, $$l = $$obj.length; pug_index5 < $$l; pug_index5++) {
        var use = $$obj[pug_index5];
pug_html = pug_html + "\u003Cdiv class=\"use\"\u003EUses " + (pug_escape(null == (pug_interp = use.quantity) ? "" : pug_interp)) + " " + (pug_escape(null == (pug_interp = use.name) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E";
      }
  } else {
    var $$l = 0;
    for (var pug_index5 in $$obj) {
      $$l++;
      var use = $$obj[pug_index5];
pug_html = pug_html + "\u003Cdiv class=\"use\"\u003EUses " + (pug_escape(null == (pug_interp = use.quantity) ? "" : pug_interp)) + " " + (pug_escape(null == (pug_interp = use.name) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E";
    }
  }
}).call(this);

pug_html = pug_html + "\u003Cdiv class=\"add-use\"\u003E\u003Cselect name=\"inventory_use_name\"\u003E";
pug_mixins["options_with_null"](generalInventory);
pug_html = pug_html + "\u003C\u002Fselect\u003E\u003Cinput name=\"inventory_use_quantity\" type=\"number\"\u003E\u003Cbutton class=\"add-inventory-use\"\u003EAdd usage\u003C\u002Fbutton\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";
    }
  }
}).call(this);

pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Chr\u003E\u003Ch2\u003EExtras\u003C\u002Fh2\u003E\u003Cdiv class=\"extras-container\"\u003E";
if (availableExtras.length > 0) {
pug_html = pug_html + "\u003Clabel\u003EAdd extra\u003C\u002Flabel\u003E\u003Cselect class=\"add-extra\"\u003E\u003Coption\u003E\u003C\u002Foption\u003E";
// iterate availableExtras
;(function(){
  var $$obj = availableExtras;
  if ('number' == typeof $$obj.length) {
      for (var pug_index6 = 0, $$l = $$obj.length; pug_index6 < $$l; pug_index6++) {
        var c = $$obj[pug_index6];
pug_html = pug_html + "\u003Coption" + (pug_attr("value", c.name, true, true)) + "\u003E" + (pug_escape(null == (pug_interp = c.name) ? "" : pug_interp)) + "\u003C\u002Foption\u003E";
      }
  } else {
    var $$l = 0;
    for (var pug_index6 in $$obj) {
      $$l++;
      var c = $$obj[pug_index6];
pug_html = pug_html + "\u003Coption" + (pug_attr("value", c.name, true, true)) + "\u003E" + (pug_escape(null == (pug_interp = c.name) ? "" : pug_interp)) + "\u003C\u002Foption\u003E";
    }
  }
}).call(this);

pug_html = pug_html + "\u003C\u002Fselect\u003E";
}
pug_html = pug_html + "\u003Cdiv class=\"extras\"\u003E";
// iterate extras || []
;(function(){
  var $$obj = extras || [];
  if ('number' == typeof $$obj.length) {
      for (var pug_index7 = 0, $$l = $$obj.length; pug_index7 < $$l; pug_index7++) {
        var extra = $$obj[pug_index7];
pug_html = pug_html + "\u003Cdiv class=\"extra pill\"\u003E" + (pug_escape(null == (pug_interp = extra.name) ? "" : pug_interp)) + "\n\u003Ca" + (" class=\"clickable remove-extra\""+pug_attr("data-name", extra.name, true, true)) + "\u003EX\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E";
      }
  } else {
    var $$l = 0;
    for (var pug_index7 in $$obj) {
      $$l++;
      var extra = $$obj[pug_index7];
pug_html = pug_html + "\u003Cdiv class=\"extra pill\"\u003E" + (pug_escape(null == (pug_interp = extra.name) ? "" : pug_interp)) + "\n\u003Ca" + (" class=\"clickable remove-extra\""+pug_attr("data-name", extra.name, true, true)) + "\u003EX\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E";
    }
  }
}).call(this);

pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"collections-container\"\u003E\u003Ch2\u003ECollections\u003C\u002Fh2\u003E";
if (availableCollections.length > 0) {
pug_html = pug_html + "\u003Clabel\u003EAdd to collection\u003C\u002Flabel\u003E\u003Cselect class=\"add-collection\"\u003E\u003Coption\u003E\u003C\u002Foption\u003E";
// iterate availableCollections
;(function(){
  var $$obj = availableCollections;
  if ('number' == typeof $$obj.length) {
      for (var pug_index8 = 0, $$l = $$obj.length; pug_index8 < $$l; pug_index8++) {
        var c = $$obj[pug_index8];
pug_html = pug_html + "\u003Coption" + (pug_attr("value", c.id, true, true)) + "\u003E" + (pug_escape(null == (pug_interp = c.name) ? "" : pug_interp)) + "\u003C\u002Foption\u003E";
      }
  } else {
    var $$l = 0;
    for (var pug_index8 in $$obj) {
      $$l++;
      var c = $$obj[pug_index8];
pug_html = pug_html + "\u003Coption" + (pug_attr("value", c.id, true, true)) + "\u003E" + (pug_escape(null == (pug_interp = c.name) ? "" : pug_interp)) + "\u003C\u002Foption\u003E";
    }
  }
}).call(this);

pug_html = pug_html + "\u003C\u002Fselect\u003E";
}
pug_html = pug_html + "\u003Cdiv class=\"collections\"\u003E";
// iterate product.collectionIds || []
;(function(){
  var $$obj = product.collectionIds || [];
  if ('number' == typeof $$obj.length) {
      for (var pug_index9 = 0, $$l = $$obj.length; pug_index9 < $$l; pug_index9++) {
        var cid = $$obj[pug_index9];
pug_html = pug_html + "\u003Cdiv class=\"collection pill\"\u003E" + (pug_escape(null == (pug_interp = collectionsById[cid] ? collectionsById[cid].name : cid) ? "" : pug_interp)) + "\n\u003Ca" + (" class=\"clickable remove-from-collection\""+pug_attr("data-cid", cid, true, true)) + "\u003EX\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E";
      }
  } else {
    var $$l = 0;
    for (var pug_index9 in $$obj) {
      $$l++;
      var cid = $$obj[pug_index9];
pug_html = pug_html + "\u003Cdiv class=\"collection pill\"\u003E" + (pug_escape(null == (pug_interp = collectionsById[cid] ? collectionsById[cid].name : cid) ? "" : pug_interp)) + "\n\u003Ca" + (" class=\"clickable remove-from-collection\""+pug_attr("data-cid", cid, true, true)) + "\u003EX\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E";
    }
  }
}).call(this);

pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cbutton class=\"save\"\u003ESave changes to product\u003C\u002Fbutton\u003E\u003Cbutton class=\"delete\"\u003EDelete product\u003C\u002Fbutton\u003E\u003Chr\u003E\u003Cdiv class=\"images-container\"\u003E\u003Cp\u003EImages\u003C\u002Fp\u003E\u003Cbutton" + (" class=\"add-image js-modal-trigger\""+pug_attr("data-target", `#${uuid}-asset-manager-modal`, true, true)) + "\u003EAdd image\u003C\u002Fbutton\u003E\u003Cdiv\u003E" + (null == (pug_interp = imageReorder || "") ? "" : pug_interp) + "\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";
}
pug_html = pug_html + "\u003Cdiv" + (" class=\"asset-manager-modal js-modal\""+pug_attr("id", `${uuid}-asset-manager-modal`, true, true)) + "\u003E\u003Cdiv class=\"content\"\u003E\u003Cdiv class=\"js-modal-trigger clickable\" style=\"float:right;\"\u003EClose\u003C\u002Fdiv\u003E\u003Cdiv\u003E" + (null == (pug_interp = assetManager) ? "" : pug_interp) + "\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";
    }.call(this, "assetManager" in locals_for_with ?
        locals_for_with.assetManager :
        typeof assetManager !== 'undefined' ? assetManager : undefined, "availableCollections" in locals_for_with ?
        locals_for_with.availableCollections :
        typeof availableCollections !== 'undefined' ? availableCollections : undefined, "availableExtras" in locals_for_with ?
        locals_for_with.availableExtras :
        typeof availableExtras !== 'undefined' ? availableExtras : undefined, "collectionsById" in locals_for_with ?
        locals_for_with.collectionsById :
        typeof collectionsById !== 'undefined' ? collectionsById : undefined, "extras" in locals_for_with ?
        locals_for_with.extras :
        typeof extras !== 'undefined' ? extras : undefined, "generalInventory" in locals_for_with ?
        locals_for_with.generalInventory :
        typeof generalInventory !== 'undefined' ? generalInventory : undefined, "imageReorder" in locals_for_with ?
        locals_for_with.imageReorder :
        typeof imageReorder !== 'undefined' ? imageReorder : undefined, "pendingChanges" in locals_for_with ?
        locals_for_with.pendingChanges :
        typeof pendingChanges !== 'undefined' ? pendingChanges : undefined, "product" in locals_for_with ?
        locals_for_with.product :
        typeof product !== 'undefined' ? product : undefined, "renderDollars" in locals_for_with ?
        locals_for_with.renderDollars :
        typeof renderDollars !== 'undefined' ? renderDollars : undefined, "sizes" in locals_for_with ?
        locals_for_with.sizes :
        typeof sizes !== 'undefined' ? sizes : undefined, "uuid" in locals_for_with ?
        locals_for_with.uuid :
        typeof uuid !== 'undefined' ? uuid : undefined));
    ;;return pug_html;}